<template>
  <module-configuration :data="config" :errors="errors" v-on:authenticated="getShoppingStores">
    <div slot="auth" class="l-row">
      <form-group label="Ambiente" :required="true">
        <select v-model="config.auth.environment" class="form-select">
          <option value="sandbox">Sandbox</option>
          <option value="production">Produção</option>
        </select>
      </form-group>
      <form-group label="Token">
        <input class="form-input" v-model="config.general.token">
      </form-group>
      <form-group label="Subdomínio">
        <input class="form-input" v-model="config.auth.subdomain">
        <small class="form-help">O subdomínio deve ser apenas o nome da loja, sem conter http, https, www, .com.br</small>
      </form-group>
    </div>
    <panel title="Centro de distribuição">
      <div class="l-row">
        <form-group label="Token">
          <input class="form-input" v-model="config.auth.token">
        </form-group>
        <form-group label="Identificador da Loja">
          <input class="form-input" v-model="config.auth.referenceCodeStore">
        </form-group>
      </div>
    </panel>
    <div>
      <panel title="Produtos">
        <div class="l-row">
          <form-group label="Sincronizar produtos automaticamente">
            <label class="form-switch">
              <input type="checkbox" v-model="config.product.synchronize">
              <span class="form-switch__indicator"></span>
            </label>
            <small class="form-help">Define se os produtos da fonte de dados devem ser sincronizados automaticamente.</small>
          </form-group>
        </div>
        <div class="l-row">
          <form-group label="Concatenar Descrição com título">    
            <multiselect v-model="config.product.lookup.descriptions" :options="descriptionGroup" :multiple="true" track-by="value" label="name" selectLabel="Clique" selectedLabel="Selecionado" placeholder="Selecione a opção">
            </multiselect>
          </form-group>
        </div>
      </panel>
    </div>
    <div>
      <panel title="Status de pedidos">
        <div slot="header-right">
          <a href="#" @click="fetchOrderStatuses()" class="btn btn--info"><i class="icon-spinner11"></i></a>
        </div>
        <loader :loading="loading"/>
        <div v-if="fetched">
          <div class="l-row">
            <form-group label="Pendente">
              <select v-model="config.order.forward.status.pending" class="form-select">
                <option :value="null">Selecione</option>
                <option v-for="status in statusesGroupedByType" :key="status.code" :value="status.code">{{ status.label }}</option>
              </select>
            </form-group>
            <form-group label="Aprovado">
              <select v-model="config.order.forward.status.approved" class="form-select">
                <option :value="null">Selecione</option>
                <option v-for="status in statusesGroupedByType" :key="status.code" :value="status.code">{{ status.label }}</option>
              </select>
            </form-group>
            <form-group label="Cancelado">
              <select v-model="config.order.forward.status.canceled" class="form-select">
                <option :value="null">Selecione</option>
                <option v-for="status in statusesGroupedByType" :key="status.code" :value="status.code">{{ status.label }}</option>
              </select>
            </form-group>
          </div>
          <div class="l-row">
            <form-group label="Transporte">
              <select v-model="config.order.forward.status.shipped" class="form-select">
                <option :value="null">Selecione</option>
                <option v-for="status in statusesGroupedByType" :key="status.code" :value="status.code">{{ status.label }}</option>
              </select>
              <small class="form-help">Somente para pedidos com serviço de entrega.</small>
            </form-group>
            <form-group label="Entregue">
              <select v-model="config.order.forward.status.delivered" class="form-select">
                <option :value="null">Selecione</option>
                <option v-for="status in statusesGroupedByType" :key="status.code" :value="status.code">{{ status.label }}</option>
              </select>
              <small class="form-help">Somente para pedidos com serviço de entrega.</small>
            </form-group>
          </div>
        </div>
        <div v-else-if="!fetching" class="u-bolder t-error u-textCenter">Não foi possível buscar os status dos pedidos do Tiny.</div>
      </panel>
    </div>
    <panel title="Frete" v-if="flexyShippingMethods.length">
      <div class="l-row">
        <form-group label="Transportadora padrão">
          <select v-model="config.order.forward.shippingMethodDefault" class="form-select" v-if="flexyShippingMethods.length">
            <option :value=null>Não utilizar</option>
            <option v-for="shippingMethod in flexyShippingMethods" :key="shippingMethod.code" :value="shippingMethod.code">{{ shippingMethod.label }}</option>
          </select>
        </form-group>
      </div>
      <div class="l-row">
        <form-group :label="shippingMethodMap.hub" v-for="shippingMethodMap in config.order.forward.shippingMethodMap" :key="shippingMethodMap.hub">
          <select v-model="shippingMethodMap.erp" class="form-select">
            <option :value=null>Não utilizar</option>
            <option v-for="shippingMethod in flexyShippingMethods" :key="shippingMethod.code" :value="shippingMethod.code">{{ shippingMethod.label }}</option>
          </select>
        </form-group>
      </div>
    </panel>
    <panel title="Pagamento" v-if="flexyPaymentMethods.length">
      <div class="l-row">
        <form-group label="Forma de pagamento padrão">
          <select v-model="config.order.forward.paymentMethodDefault" class="form-select" v-if="flexyPaymentMethods.length">
            <option :value=null>Não utilizar</option>
            <option v-for="paymentMethod in flexyPaymentMethods" :key="paymentMethod.code" :value="paymentMethod.code">{{ paymentMethod.label }}</option>
          </select>
        </form-group>
      </div>
    </panel>
  </module-configuration>
</template>

<script>
  import ModuleConfiguration from '@/views/Configuration/Shared'
  import { mapActions, mapGetters } from 'vuex'
  import api from '@/api'
  import Multiselect from 'vue-multiselect'
  import FormGroup from '@/components/template/FormGroup'
  import Panel from '@/components/template/Panel'
  import Loader from '@/components/template/Loader'

  export default {
    provide: {
      moduleDI: {
        type: 'erp',
        identifier: 'flexy'
      }
    },
    data: () => ({
      loading: false,
      type: 'erp',
      identifier: 'flexy',
      fetching: true,
      errors: [],
      config: {
        product: {
          synchronize: false,
          lookup: {
            descriptions: null
          }
        },
        auth: {
          environment: 'sandbox',
          token: null,
          referenceCode: null,
          subdomain: null
        },
        general: {
          token: null
        },
        order: {
          forward: {
            status: {
              approved: null,
              pending: null,
              canceled: null,
              shipped: null,
              delivered: null
            },
            shippingMethodDefault: null,
            shippingMethodMap: [],
            paymentMethodDefault: null
          }
        }
      },
      flexyShippingMethods: [],
      hubShippingMethods: [],
      flexyPaymentMethods: [],
      descriptionGroup: [
        {value: 'descriptionOne', name: 'Descrição 01'},
        {value: 'descriptionTwo', name: 'Descrição 02'},
        {value: 'descriptionThree', name: 'Descrição 03'},
        {value: 'descriptionFour', name: 'Descrição 04'}
      ],
      flexyStores: []
    }),
    async mounted () {
      await this.fetchOrderStatuses()
      api.flexy.getOrderShippingMethods()
        .then(shippingMethods => {
          this.flexyShippingMethods = shippingMethods
        })
        .catch(() => {})

      api.flexy.getOrderPaymentMethods()
        .then(paymentMethods => {
          this.flexyPaymentMethods = paymentMethods
        })
        .catch(() => {})

      api.getOrderShippingMethods(this.type, this.identifier)
        .then(shippingMethods => {
          this.hubShippingMethods = shippingMethods
          this.config.order.forward.shippingMethodMap = shippingMethods.map((shippingMethod, index) => {
            let erp = null
            if (this.config.order.forward.shippingMethodMap[index] !== undefined) {
              erp = this.config.order.forward.shippingMethodMap[index].erp
            }

            return {
              erp: erp,
              hub: shippingMethod
            }
          })
        })
        .catch(() => {})
    },
    methods: {
      ...mapActions('orderStatuses', [
        'fetch'
      ]),
      async fetchOrderStatuses () {
        this.fetching = true
        this.loading = true
        await this.fetch({
          type: this.type,
          identifier: this.identifier
        })
        this.fetching = false
        this.loading = false
      },
      getError (input) {
        const error = this.errors.find(item => item.input === input)
        return error ? { message: error.message, value: error.value } : { message: null, value: null }
      }
    },
    computed: {
      ...mapGetters('orderStatuses', [
        'findByModuleTypeAndIdentifier'
      ]),
      fetched () {
        return Object.keys(this.statusesGroupedByType).length
      },
      statusesGroupedByType () {
        return this.findByModuleTypeAndIdentifier(this.type, this.identifier)
      }
    },
    components: {
      FormGroup,
      ModuleConfiguration,
      Panel,
      Multiselect,
      Loader
    }
  }
</script>



// WEBPACK FOOTER //
// Flexy.vue?0b41e8c2